// ─────────────────────────────────────────────────────────────────────────────
// card-product-variant-selection-custom.js  (FIXED – AJAX Filter Compatible)
// Problem: Images were only updating on full page refresh because the event
// listener was bound only once on DOMContentLoaded. When Shopify's AJAX
// filters re-render the product grid, new HTML is injected but the old
// listeners are gone.
// Fix: Use MutationObserver + re-attach listeners every time the grid changes.
// ─────────────────────────────────────────────────────────────────────────────

function attachSwatchListeners() {
  var productGrids = document.querySelectorAll(".grid.product-grid");

  productGrids.forEach(function (productGrid) {
    // Prevent double-binding on the same grid element
    if (productGrid.dataset.swatchListenerAttached === "true") return;
    productGrid.dataset.swatchListenerAttached = "true";

    var sectionId = productGrid.getAttribute("data-section-id");

    productGrid.addEventListener("change", function (e) {
      if (
        e.target.matches(
          'input[type="radio"][data-section-id="' + sectionId + '"]'
        )
      ) {
        // variantDataMap may have been re-injected by Shopify after AJAX,
        // so always read it fresh from window instead of caching it once.
        var variantDataMap =
          window["variantDataMap" + sectionId.replace(/-/g, "_")];

        if (!variantDataMap) {
          console.log("variantDataMap not found for section:", sectionId);
          return;
        }

        var card = e.target.closest(
          `.card-product-custom-div[data-section-id="${sectionId}"]`
        );
        var variantId = e.target.getAttribute("data-variant-id");
        var variantData = variantDataMap[variantId];

        if (!variantData) {
          console.log("No data found for variant:", variantId);
          return;
        }

        // Update the product image
        var productImageElement = card.querySelector(".card__media img");
        if (productImageElement) {
          var lazyLoadAllVariants =
            card.getAttribute("data-lazy-load-all-variants") === "true";

          if (lazyLoadAllVariants) {
            var preloadedImage = card.querySelector(
              `img[data-variant-id="${variantId}"]`
            );
            if (preloadedImage) {
              productImageElement.src = preloadedImage.src;
              productImageElement.srcset = preloadedImage.srcset;
            } else {
              console.log(
                "Matching preloaded image not found for variant:",
                variantId
              );
            }
          } else {
            var dynamicSrcset = [
              variantData.imageUrl + "?width=165 165w",
              variantData.imageUrl + "?width=360 360w",
              variantData.imageUrl + "?width=533 533w",
              variantData.imageUrl + "?width=720 720w",
              variantData.imageUrl + "?width=940 940w",
              variantData.imageUrl + "?width=1066 1066w",
            ].join(", ");
            productImageElement.srcset = dynamicSrcset;
            productImageElement.src = variantData.imageUrl;
          }
        } else {
          console.log("No product image element found in this card.");
        }

        // Update the product URL
        var productLinks = card.querySelectorAll(
          'a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]'
        );
        productLinks.forEach(function (link) {
          link.href = variantData.productUrl;
        });
      }
    });
  });
}

// ── 1. Run on initial page load ───────────────────────────────────────────────
document.addEventListener("DOMContentLoaded", attachSwatchListeners);

// ── 2. Re-run when Shopify AJAX filter injects new HTML ───────────────────────
// Shopify's native filtering fires this custom event after re-rendering sections
document.addEventListener("shopify:section:load", function () {
  // Reset flags so listeners can be re-attached to freshly injected grids
  document.querySelectorAll(".grid.product-grid").forEach(function (grid) {
    delete grid.dataset.swatchListenerAttached;
  });
  attachSwatchListeners();
});

// ── 3. MutationObserver fallback (for themes that don't fire section:load) ────
// Watches the body for new .grid.product-grid elements being added to the DOM
var observer = new MutationObserver(function (mutations) {
  var shouldReattach = false;

  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return; // skip text nodes
      // Check if the added node IS a product grid or CONTAINS one
      if (
        node.matches(".grid.product-grid") ||
        node.querySelector(".grid.product-grid")
      ) {
        shouldReattach = true;
      }
    });
  });

  if (shouldReattach) {
    // Reset flags on all grids so re-attachment works correctly
    document.querySelectorAll(".grid.product-grid").forEach(function (grid) {
      delete grid.dataset.swatchListenerAttached;
    });
    attachSwatchListeners();
  }
});

observer.observe(document.body, { childList: true, subtree: true });